import { createAsyncThunk } from '@reduxjs/toolkit';
import { API } from '../../axios/instance';
import { getUserContext } from '../../utils/auth';

export const fetchLabels = createAsyncThunk('label/fetchAll', async () => {
  const { userId, businessId } = getUserContext();
  const res = await API.get('contact/label', {
    params: {
      ...(userId ? { userId } : {}),
      ...(businessId ? { businessId } : {}),
    }
  });
  return res.data;
});

export const createLabel = createAsyncThunk('label/create', async (payload) => {
  const { userId, businessId } = getUserContext();
  const res = await API.post('contact/label/create-label', {
    ...(userId ? { userId } : {}),
    ...(businessId ? { businessId } : {}),
    ...payload,
  });
  return res.data?.result || res.data;
});

export const updateLabel = createAsyncThunk('label/update', async ({ id, data }) => {
  const res = await API.put(`contact/label/${id}`, data);
  return res.data?.result || res.data;
});

export const deleteLabel = createAsyncThunk('label/delete', async (id) => {
  await API.delete(`contact/label/${id}`);
  return id;
});
